import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class InvestmentsDomainService {
  constructor(private commonService: CommonService) {}

  getInvestments(
    siteId: any,
    investorId: any,
    searchText: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    filterByStatus: any
  ) {
    return this.commonService.API_GET(
      EndPoints.GetAllInvestments +
        `?siteId=${siteId}&InvesterId=${investorId}&searchText=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&filterByStatus=${filterByStatus}`,
      false
    );
  }

  confirmInvestment(formdata: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.ConfirmInvestment, formdata, false, {
      headers: hd,
    });
  }

  editPdfFiles(file: any, page: any, editAction: any, rotateDeg: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(
      EndPoints.EditPDFFiles + `?page=${page}&EditAction=${editAction}&rotateDeg=${rotateDeg}`,
      file,
      false,
      {
        headers: hd,
      }
    );
  }

  getVendorDropdownList(siteId: any, searchText: string) {
    return this.commonService.API_GET(
      EndPoints.GetVendorDropdownList + `?siteId=${siteId}&searchText=${searchText}`,
      false
    );
  }

  getVendorDetails(vendorId: any) {
    return this.commonService.API_GET(EndPoints.GetVendorDetails + `?VendorId=${vendorId}`, false);
  }

  schedulePayment(paymentData: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.SchedulePayment, paymentData, false, {
      headers: hd,
    });
  }

  getPaymentDetails(paymentId: any) {
    return this.commonService.API_GET(EndPoints.GetPayment + `?PaymentId=${paymentId}`, false);
  }

  getInvestmentHistory(investorId: any, siteId: any) {
    return this.commonService.API_GET(
      EndPoints.GetInvestmentHistory + `?parentInvestorId=${investorId}&siteId=${siteId}`,
      false
    );
  }

  getAssignmentAndAgreementDetails() {
    return this.commonService.API_GET(EndPoints.GetAssignmentAndAgreementDate, false);
  }
}
